<template>
  <component :is="component" v-if="component" :memberData="memberData" :paginationData="paginationData"></component>
</template>

<script>
export default {
  name: "MemberListLink",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
    listLayout: '',
    memberData: {default: () => []},
    paginationData: {default: {page: 1, size: 10, total: 0}},
  },
  data() {
    return{
      component: null,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
    this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/member/list/MemberListDefaultLayout');
        })
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
    loader() {
      if (!this.listLayout) {
        return null
      }
      return () => import(`@/template/member/list/${this.listLayout}`)
    },
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>